import { Loader2 } from 'lucide-react';

type DeleteLinkModalProps = {
  open: boolean;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DeleteLinkModal({ open, isDeleting, onCancel, onConfirm }: DeleteLinkModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/40"
        aria-label="Close"
        onClick={onCancel}
      />
      <div className="camp-fade-up relative z-10 w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
        <h2 className="m-0 text-lg font-semibold text-[var(--dash-ink)]">Delete Shared Link</h2>
        <p className="mt-2 mb-0 text-sm text-[var(--dash-muted)]">
          Are you sure you want to delete this shared link? People using this link will no
          longer be able to access the dashboard.
        </p>
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="h-10 rounded-xl px-4 text-sm font-medium text-[var(--dash-muted)] hover:bg-[var(--dash-soft)]"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={isDeleting}
            onClick={onConfirm}
            className="inline-flex h-10 items-center gap-2 rounded-xl bg-red-600 px-4 text-sm font-semibold text-white disabled:opacity-50"
          >
            {isDeleting ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            Delete Link
          </button>
        </div>
      </div>
    </div>
  );
}
